// extracted by mini-css-extract-plugin
export var cmtSSimpleSplash = "styles-module--cmt-s-simple-splash--11304";
export var cmtSSimpleSplash__date = "styles-module--cmt-s-simple-splash__date--f0451";
export var cmtSSimpleSplash__image = "styles-module--cmt-s-simple-splash__image--94d87";
export var cmtSSimpleSplash__imageWrapper = "styles-module--cmt-s-simple-splash__image-wrapper--46ea2";
export var cmtSSimpleSplash__sliceColumn = "styles-module--cmt-s-simple-splash__slice-column--bd053";
export var cmtSSimpleSplash__sliceInner = "styles-module--cmt-s-simple-splash__slice-inner--66c62";
export var cmtSSimpleSplash__title = "styles-module--cmt-s-simple-splash__title--7f485";